import { GridFields } from 'components';
import { useTranslation } from 'libs/i18n';
import { Field } from 'modules/operation/common/forms/operationForm';

import { Section } from '../../Section';

export const AdditionalNotesSection = () => {
  const { t } = useTranslation();

  return (
    <Section
      datax="operation-additionalNotesSection"
      title={t('operation.sections.additionalNotesSection.title')}
    >
      <GridFields>
        <Field.Text
          multiline
          label={t(
            'operation.sections.additionalNotesSection.fields.additionalNotes.label'
          )}
          name="additionalNotes"
        />
      </GridFields>
    </Section>
  );
};
